/**
 * Truncates text in the middle, preserving the beginning and end
 * Example: "DIRECCION DE ADMINISTRACION Y FINANZAS" → "DIRECCION DE...Y FINANZAS"
 */
export function truncateMiddle(
  text: string,
  maxLength = 10,
  startLength?: number,
  endLength?: number
): string {
  if (!text || text.length <= maxLength) {
    return text;
  }

  // Calculate default lengths if not provided
  const defaultStartLength = Math.floor(maxLength * 0.6);
  const defaultEndLength = Math.floor(maxLength * 0.3);
  
  const start = startLength ?? defaultStartLength;
  const end = endLength ?? defaultEndLength;

  // Ensure we don't exceed the original text length
  if (start + end >= text.length) {
    return text;
  }

  const startText = text.slice(0, start).trim();
  const endText = text.slice(-end).trim();
  
  return `${startText}...${endText}`;
}

/**
 * Capitalizes the first letter of each word
 */
export function titleCase(text: string): string {
  return text
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}